import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Category } from 'src/app/models/category';
import { CategoryService } from 'src/app/services/category.service';
import { AddCategoryComponent } from '../add-category/add-category.component';
import { CategoryComponent } from '../category/category.component';
import { EditCategoryComponent } from '../edit-category/edit-category.component';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css']
})
export class CategoriesComponent implements OnInit {
  displayedColumns: string[] = ['nombre'];
  dataSource: MatTableDataSource<any>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  public company!: string;
  public categories: Category[] = [];
  public categoriesFiltered: Category[] = [];
  public isConfirm: boolean;
  public category: Category;

  constructor(
    private _categoryService: CategoryService,
    public dialog: MatDialog,
  ) {
    this.company = localStorage.getItem('TOKEN');
  }

  ngOnInit(): void {
    this.getCategories();
  }

  ngAfterViewInit() {
    this.getCategories();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) this.dataSource.paginator.firstPage();
  }

  getCategories() {
    this._categoryService.getCategories().subscribe(
      res => {
        console.log(res)
        if (res.categoria) {
          this.categories = res.categoria;
          // this.dataSource
          console.log(res)
          this.dataSource = new MatTableDataSource(res.categoria);
        }

      }
    )
  }

  delete(id) {
    let message = confirm("Desea eliminar este producto?");
    if (message) {
      this._categoryService.deleteCategory(id).subscribe(
        response => { this.ngAfterViewInit(); },
        error => { console.log(<any>error); }
      )
    } else { console.log('Producto no eliminado'); }
  }


  edit(id) {
    const dialogRef = this.dialog.open(EditCategoryComponent, { data: { _id: id } });
    dialogRef.afterClosed().subscribe(result => { this.ngAfterViewInit(); });
  }

  view(id) {
    const dialogRef = this.dialog.open(CategoryComponent, { data: { _id: id } });
    dialogRef.afterClosed().subscribe(result => { this.ngAfterViewInit(); });
  }

  addCategory() {

  }

  add() {
    const dialogRef = this.dialog.open(AddCategoryComponent);
    dialogRef.afterClosed().subscribe(result => { this.ngAfterViewInit(); });
  }
}
